import { resourceSelectorInitialState, resourceSelectorReducer } from '../../../common/resource/reducer'
import {
  CONNECTORS_ICONS_PREFIX,
  CONNECTORS_ICONS_RESOURCE_NAME,
  ConnectorsIconsFetcherState,
  logPointsLandingOrigin,
  logPointsOrigin,
  LogPointsState
} from './model'
import { selectorInitialState } from '../../../common/redux/selector/reducerFor'
import { environmentSelectorReducer } from '../../../common/environment/reducer'
import { versionSelectorReducer } from '../../../common/version/reducer'
import { ActionType, ConnectorsIconAction, FetchLogPointsResourcesAction, LogPointsAction, SetStateFromLandingAction } from './actions'
import apisReducer, { logPointsAPIInitialState } from '../LogPointsBody/LogPointsAPIsBody/reducer'
import appsReducer, { logPointsApplicationsInitialState } from '../LogPointsBody/LogPointsApplicationsBody/reducer'
import { LogPointsAPIAction } from '../LogPointsBody/LogPointsAPIsBody/actions'
import fetchReducerFor, { fetchInitialState } from '../../../common/redux/fetch/reducerFor'
import { LogPointsConnectors } from '../../../remote-api/models'
import { LogPointsApplicationsAction } from '../LogPointsBody/LogPointsApplicationsBody/actions'

const landingPageInitialState = {
  environmentSelector: selectorInitialState,
  resourceSelector: resourceSelectorInitialState,
  versionSelector: selectorInitialState,
}

const connectorsInitialState = {...fetchInitialState}

export const initialState: LogPointsState = {
  landingPage: landingPageInitialState,
  apis: logPointsAPIInitialState,
  environmentSelector: selectorInitialState,
  resourceSelector: resourceSelectorInitialState,
  versionSelector: selectorInitialState,
  apps: logPointsApplicationsInitialState,
  connectors: connectorsInitialState
}

const connectorsReducer = () => {
  const connectorsFetchReducerForOrigin =
    fetchReducerFor<LogPointsConnectors>(CONNECTORS_ICONS_RESOURCE_NAME, CONNECTORS_ICONS_PREFIX, logPointsOrigin)
  return function reducer(state: ConnectorsIconsFetcherState = connectorsInitialState, action: ConnectorsIconAction): ConnectorsIconsFetcherState {
    return {
      ...state,
      ...connectorsFetchReducerForOrigin(state, action)
    }
  }
}

const environmentLogPointsReducer = environmentSelectorReducer(logPointsOrigin)
const environmentLandingReducer = environmentSelectorReducer(logPointsLandingOrigin)
const resourceLogPointsReducer = resourceSelectorReducer(logPointsOrigin)
const resourceLandingReducer = resourceSelectorReducer(logPointsLandingOrigin)
const versionLogPointsReducer = versionSelectorReducer(logPointsOrigin)
const versionLandingReducer = versionSelectorReducer(logPointsLandingOrigin)
const logPointsConnectorsReducer = connectorsReducer()

const reducer = (state: LogPointsState = initialState, action: LogPointsAction): LogPointsState => {
  state = {
    ...state,
    landingPage: {
      environmentSelector: environmentLandingReducer(state.landingPage.environmentSelector, action),
      resourceSelector: resourceLandingReducer(state.landingPage.resourceSelector, action),
      versionSelector: versionLandingReducer(state.landingPage.versionSelector, action),
    },
    environmentSelector: environmentLogPointsReducer(state.environmentSelector, action),
    resourceSelector: resourceLogPointsReducer(state.resourceSelector, action),
    versionSelector: versionLogPointsReducer(state.versionSelector, action),
    apis: apisReducer(state.apis, action as LogPointsAPIAction),
    apps: appsReducer(state.apps, action as LogPointsApplicationsAction),
    connectors: logPointsConnectorsReducer(state.connectors, action)
  }

  switch (action.type) {
    case ActionType.SetStateFromLanding:
      return {
        ...state,
        environmentSelector: (action as SetStateFromLandingAction).payload.environmentSelector,
        resourceSelector: (action as SetStateFromLandingAction).payload.resourceSelector,
        versionSelector: (action as SetStateFromLandingAction).payload.versionSelector
      }
  
    case ActionType.FetchLogPointsResources:
      return {
        ...state,
        resourceSelector: {
          ...state.resourceSelector,
          resources: (action as FetchLogPointsResourcesAction).payload.resources
        },
      }

    default:
      return state
  }
}

export default reducer
